module.exports = __webpack_public_path__ + "img/benefits-player.9d280116.png";